import React from "react";
import Lottie from "react-lottie";
import readingBook from "../../../assets/reading-book.json";
import { BottomLine, PrimaryBtn } from "../../../components";
import { FaHome } from "react-icons/fa";
import { Link } from "react-router-dom";

const Education = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: readingBook,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="pt-24">
      <div className="mb-12">
        <h3 className="text-center text-neutral">My Certificates</h3>
        <h1 className="text-4xl font-semibold drop-shadow-md text-center mb-5">
          My <span className="text-primary">Qualification</span>
        </h1>
        <BottomLine />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-8">
        <div className="">
          <Lottie
            options={defaultOptions}
            height="70%"
            width="90%"
            className="mx-auto lg:mr-auto"
          />
        </div>
        <div className="mx-auto lg:ml-auto">
          {/* Diploma */}
          <div className="p-6 bg-[#313131] bg-opacity-90 backdrop-blur-lg rounded-lg shadow-lg inline-block w-[300px] hover:shadow-primary duration-300 cursor-pointer">
            <div className="text-left mb-4">
              <h3 className="text-2xl font-semibold text-primary">
                Diploma in Electrical and Electronic Engineering
              </h3>
              <p className="text-sm text-neutral font-semibold">2019 - 2024</p>
            </div>
            <p className="text-sm text-neutral text-justify">
              I am currently studying in the last year of Electrical and
              Electronic Engineering in Harran University at Şanlıurfa, Turkey
            </p>
          </div>

          {/* MERN Developer */}
          <div className="my-6 md:my-4 md:ml-[200px] p-6 bg-[#313131] bg-opacity-90 backdrop-blur-lg rounded-lg shadow-lg w-[300px] hover:shadow-primary duration-300 cursor-pointer">
            <div className="text-left mb-4">
              <h3 className="text-2xl font-semibold text-primary">
                Full-Stack Web Developer
              </h3>
              <p className="text-sm text-neutral font-semibold">
                12/2022 - 09/2023
              </p>
            </div>
            <p className="text-sm text-neutral text-justify">
              I have completed the <b>MERN Web Developer internership</b> from
              ALbonyan Almarsos, I got 9 Certificates in total. <br />
              Through this internship I was able to take courses of over 250h of
              content.
            </p>
          </div>

          {/* Web Developer */}
          <div className="p-6 bg-[#313131] bg-opacity-90 backdrop-blur-lg rounded-lg shadow-lg w-[300px] hover:shadow-primary duration-300 cursor-pointer">
            <div className="text-left mb-4">
              <h3 className="text-2xl font-semibold text-primary">
                ZTM Certificate
              </h3>
              <p className="text-sm text-neutral font-semibold">2023</p>
            </div>
            <p className="text-sm text-neutral text-justify">
              I have passed the Complete Web Development path from ZTM Web
              School
            </p>
          </div>
        </div>
      </div>
      <Link to="/">
        <PrimaryBtn className={"mt-5"}>
          <span>Go To HomePage</span>
          <span>
            <FaHome></FaHome>
          </span>
        </PrimaryBtn>
      </Link>
    </div>
  );
};

export default Education;
